
import { Component, Vue } from 'vue-property-decorator';
import SectionTitle from '@/components/SectionTitle.vue';

@Component({
  name: 'SectionWhySalem',
  components: { SectionTitle }
})
export default class SectionWhySalemComponent extends Vue {}
